import React, { Fragment } from "react";

import img13 from "../../../images/service/E-Commerce Blockchain Development/real estate.png";
import img14 from "../../../images/service/E-Commerce Blockchain Development/real estate (2).png";
import img15 from "../../../images/service/E-Commerce Blockchain Development/real estate (3).png";

// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Property Tokenization",
    content:
      "Convert real estate assets into digital tokens to enable fractional ownership and increase liquidity.",
  },
  {
    icon: sIcon2,
    title: "Smart Contract Transactions",
    content:
      "Automate property purchases, rentals, and transfers with transparent, self-executing contracts.",
  },
  {
    icon: sIcon3,
    title: "Decentralized Property Records",
    content:
      "Maintain immutable land registry and ownership records that eliminate fraud and disputes.",
  },
];

const benefits = [
  {
    title: "Enhanced Transparency",
    description:
      "Blockchain provides immutable records of property ownership, transaction history, and title deeds for complete transparency.",
    icon: sIcon1,
  },
  {
    title: "Fractional Ownership",
    description:
      "Tokenization enables investors to own fractions of properties, democratizing real estate investment opportunities.",
    icon: sIcon2,
  },
  {
    title: "Reduced Transaction Costs",
    description:
      "Eliminate intermediaries like brokers and lawyers to significantly reduce closing costs and processing fees.",
    icon: sIcon3,
  },
  {
    title: "Faster Transactions",
    description:
      "Smart contracts automate verification and transfer processes, reducing property transaction time from weeks to hours.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What is real estate blockchain development?",
    a: "Real estate blockchain development creates decentralized platforms for property tokenization, transparent transactions, and immutable ownership records using distributed ledger technology.",
  },
  {
    q: "How does blockchain improve property transactions?",
    a: "Blockchain eliminates intermediaries, automates processes with smart contracts, and provides transparent, immutable records that accelerate transactions and reduce costs.",
  },
  {
    q: "What is property tokenization?",
    a: "Property tokenization converts real estate assets into digital tokens on blockchain, enabling fractional ownership, increased liquidity, and global investment access.",
  },
  {
    q: "Is blockchain secure for real estate records?",
    a: "Yes—blockchain's decentralized structure and cryptographic security make property records tamper-proof and highly secure against fraud and unauthorized changes.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function RealEstateBlockchainDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Real Estate Blockchain Development"
        pagesub="Transform property transactions with transparent, secure blockchain solutions"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Revolutionize{" "}
            <span className="gradient-text">Real Estate</span>{" "}
            with Blockchain
          </>
        }
        subtitle={`Leverage blockchain technology to tokenize properties, streamline transactions, and create transparent, 
efficient real estate ecosystems with reduced costs and increased accessibility.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Real Estate Blockchain Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="Why Blockchain for Real Estate?"
        image={img14}
        paragraphs={[
          "Blockchain transforms real estate by introducing transparency, efficiency, and accessibility to property markets. Smart contracts eliminate intermediaries while tokenization unlocks fractional ownership opportunities.",
          "By creating immutable property records and automating transaction processes, blockchain reduces fraud, accelerates deals, and opens real estate investment to a global audience.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Core Real Estate Blockchain Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Challenges in Traditional Real Estate"
        image={img15}
        paragraphs={[
          "Traditional real estate suffers from lengthy transaction processes, high intermediary costs, limited liquidity, and fraud risks from paper-based title systems and opaque ownership records.",
          "Blockchain addresses these pain points by digitizing property records, automating transactions, enabling fractional ownership, and providing transparent, tamper-proof audit trails for all stakeholders.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Blockchain in Real Estate"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Real Estate Blockchain Solutions"
        subtitle="Build trust and efficiency in property markets with cutting-edge technology"
        features={[
          {
            icon: sIcon1,
            title: "Digital Property Tokens",
            description:
              "Create fungible or non-fungible tokens representing property ownership shares.",
          },
          {
            icon: sIcon2,
            title: "Immutable Land Registry",
            description:
              "Maintain permanent, tamper-proof records of ownership and transaction history.",
          },
          {
            icon: sIcon3,
            title: "Automated Escrow",
            description:
              "Smart contracts hold funds securely and release upon meeting predefined conditions.",
          },
          {
            icon: sIcon4,
            title: "Global Accessibility",
            description:
              "Enable international investors to participate in local real estate markets seamlessly.",
          },
          {
            icon: sIcon5,
            title: "Instant Verification",
            description:
              "Verify ownership, liens, and property details instantly through blockchain queries.",
          },
          {
            icon: sIcon6,
            title: "Regulatory Compliance",
            description:
              "Built-in compliance frameworks ensure adherence to local property laws and regulations.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Expert team in property tokenization and blockchain development",
          "End-to-end solutions from strategy to deployment",
          "Proven track record in real estate digital transformation",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
